module.exports = __webpack_public_path__ + "img/user.196ecaf1.png";